/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmMatchingPolicySummaryDto } from './MdmMatchingPolicySummaryDto';
import {
    MdmMatchingPolicySummaryDtoFromJSON,
    MdmMatchingPolicySummaryDtoFromJSONTyped,
    MdmMatchingPolicySummaryDtoToJSON,
    MdmMatchingPolicySummaryDtoToJSONTyped,
} from './MdmMatchingPolicySummaryDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface MdmMatchingPolicyListResponse
 */
export interface MdmMatchingPolicyListResponse {
    /**
     * 
     * @type {Array<MdmMatchingPolicySummaryDto>}
     * @memberof MdmMatchingPolicyListResponse
     */
    policies?: Array<MdmMatchingPolicySummaryDto>;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyListResponse
     */
    activeConfigurationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyListResponse
     */
    legacyRulesFallback?: boolean;
    /**
     * 
     * @type {MdmMatchingPolicySummaryDto}
     * @memberof MdmMatchingPolicyListResponse
     */
    effectivePolicy?: MdmMatchingPolicySummaryDto;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof MdmMatchingPolicyListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MdmMatchingPolicyListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MdmMatchingPolicyListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MdmMatchingPolicyListResponse interface.
 */
export function instanceOfMdmMatchingPolicyListResponse(value: object): value is MdmMatchingPolicyListResponse {
    return true;
}

export function MdmMatchingPolicyListResponseFromJSON(json: any): MdmMatchingPolicyListResponse {
    return MdmMatchingPolicyListResponseFromJSONTyped(json, false);
}

export function MdmMatchingPolicyListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchingPolicyListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'policies': json['policies'] == null ? undefined : ((json['policies'] as Array<any>).map(MdmMatchingPolicySummaryDtoFromJSON)),
        'activeConfigurationId': json['activeConfigurationId'] == null ? undefined : json['activeConfigurationId'],
        'legacyRulesFallback': json['legacyRulesFallback'] == null ? undefined : json['legacyRulesFallback'],
        'effectivePolicy': json['effectivePolicy'] == null ? undefined : MdmMatchingPolicySummaryDtoFromJSON(json['effectivePolicy']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MdmMatchingPolicyListResponseToJSON(json: any): MdmMatchingPolicyListResponse {
    return MdmMatchingPolicyListResponseToJSONTyped(json, false);
}

export function MdmMatchingPolicyListResponseToJSONTyped(value?: MdmMatchingPolicyListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policies': value['policies'] == null ? undefined : ((value['policies'] as Array<any>).map(MdmMatchingPolicySummaryDtoToJSON)),
        'activeConfigurationId': value['activeConfigurationId'],
        'legacyRulesFallback': value['legacyRulesFallback'],
        'effectivePolicy': MdmMatchingPolicySummaryDtoToJSON(value['effectivePolicy']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

